export function isForeignCompany(company) {
  return company && company.countryCode !== 'my';
}



// WEBPACK FOOTER //
// ./src/utils/companies.js